module.exports = __webpack_public_path__ + "officialStatic/img/sw16.78a4926.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/sw16.png
// module id = /MOj
// module chunks = 0